import React, { useEffect, useState } from 'react';
import './GanttChartTwo.scss';
import DynaSelectBox from "../../../DynaView/DynaSelectBox";
import _axios from "../../../../../httpService";
import { prefixUrl } from "../../../../../utils/utilsData";
import { toast } from "react-toastify";

const GanttChartTwo = ({ data, projects, DefaultValues }) => {
  const [componentData, setComponentData] = useState({
    month: [],
    phases: [],
  });
  const [projectId, setProjectId] = useState("")

  useEffect(() => {
    setComponentData(data)
    setProjectId(DefaultValues?.projectId)
  }, []);

  const filterHandler = async () => {
    const response = await _axios.get(prefixUrl() + `/arkaMonitoring/?request=phaseGanttChart&projectId=${projectId}`)
    if (response?.data?.status) {
      setComponentData(response?.data?.data)
    } else {
      toast.error(response?.data?.message)
    }
  }

  try {
    return (
      <section className={"GanttChartTwo"}>

        <h5>گانت چارت مدیت فاز</h5>
        <div className={"row-select-box"}>
          <DynaSelectBox options={projects}
            hasFilter={false}
            label={"نام پروژه"}
            className={"solid-dyna-input"}
            value={projectId.toString()}
            onChange={(data) => setProjectId(data.value)}
          />
          <button className={"filter-but"} onClick={filterHandler}>فیلتر</button>
        </div>
        {componentData?.month.length > 0 ?
          <ul className={"GanttChartTwo-list"}>
            {componentData?.month.slice().reverse().map((item, index) =>
              <li key={"mn" + index}>
                {componentData?.phases.map((ph, row) =>
                  <div className={"cell-box"} key={"cell" + row}
                    style={item?.active_phases.includes(ph.id) ? { backgroundColor: "#1B9C85" } : {}}></div>
                )}
                <div className={"caption-side"}>
                  <h6>{item?.month}</h6>
                  <h6>{item?.year}</h6>
                </div>
              </li>
            )}

            <li className={"show-ph-number"}>
              {componentData?.phases.map((ph, indexRow) =>
                <h6 key={"v" + indexRow}>{ph?.name}</h6>
              )}
            </li>
          </ul> : <h6 className={"no-data"}>اطلاعات یافت نشد</h6>
        }
      </section>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default GanttChartTwo;
